import { render } from "./EasyReach.vue?vue&type=template&id=537534ad"
import script from "./EasyReach.vue?vue&type=script&lang=js"
export * from "./EasyReach.vue?vue&type=script&lang=js"

import "./EasyReach.vue?vue&type=style&index=0&id=537534ad&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__